import { Column } from "../containers";
import { SkeletonRounded } from "../misc";

const SKELETON_ROW_HEIGHT = 70;

/**
 * Whole-table loading state. Renders `rowsPerPage` full-width skeleton bars in
 * a column. Mounted by the orchestrator when `loading: true` (works for both
 * flat and grouped modes; no column-alignment specifics needed at this stage).
 */
export function BodySkeleton({ rowsPerPage }: { rowsPerPage: number }) {
    return (
        <Column sx={{ px: 1, py: 2 }}>
            {Array(rowsPerPage)
                .fill(null)
                .map((_, i) => (
                    <SkeletonRounded key={i} width="100%" height={SKELETON_ROW_HEIGHT} sx={{ marginBottom: "2px" }} />
                ))}
        </Column>
    );
}
